import { currentUser } from '@admin/config/current_user';
import { WarehouseTask__ViewMode } from '@admin/schema';

const AT_MY_WAREHOUSES_ROLES = ['manager', 'ops_leadership'] as const;

export const showAtMyWarehousesViewMode = (): boolean =>
  currentUser.roles.some((role) => (AT_MY_WAREHOUSES_ROLES as readonly string[]).includes(role));

export const defaultWarehouseTaskViewMode = (): WarehouseTask__ViewMode => {
  if (currentUser.roles.includes('admin')) {
    return WarehouseTask__ViewMode.All;
  }
  if (showAtMyWarehousesViewMode()) {
    return WarehouseTask__ViewMode.AtMyWarehouses;
  }
  return WarehouseTask__ViewMode.CreatedByMe;
};
